import { Sprout, Mail, Facebook } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "../../i18n/LanguageContext";

export const Footer = () => {
  const { t } = useLang();

  return (
    <footer
      data-testid="site-footer"
      className="bg-stone-900 text-stone-300"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-stone-50 grid place-items-center text-green-900">
                <Sprout size={18} strokeWidth={2.5} />
              </span>
              <span className="font-display text-xl text-stone-50">
                Get Easy Statement
              </span>
            </div>
            <p className="mt-4 text-stone-400 leading-relaxed max-w-md">
              {t.footer.tagline}
            </p>
            <div className="mt-6 flex flex-col gap-3 text-sm text-stone-400">
              <a
                href="mailto:info@geteasystatement.com"
                className="flex items-center gap-2 hover:text-stone-50 transition"
              >
                <Mail size={15} /> info@geteasystatement.com
              </a>
              <a
                href="https://www.facebook.com/share/14hJ71Kg1dY/"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 hover:text-[#1877F2] transition"
              >
                <Facebook size={15} /> Flame Enterprises
              </a>
            </div>

            <Link
              to="/download"
              data-testid="play-store-badge"
              aria-label="Download App"
              className="mt-6 inline-block hover:opacity-90 transition"
            >
              <img
                src="https://play.google.com/intl/en_us/badges/static/images/badges/en_badge_web_generic.png"
                alt="Download the App"
                className="h-14 w-auto"
                width="646"
                height="250"
              />
            </Link>
          </div>

          <FooterCol
            title={t.footer.product}
            links={[
              { label: t.nav.features, href: "/#features" },
              { label: t.nav.howItWorks, href: "/#how" },
              { label: t.nav.pricing, href: "/#pricing" },
            ]}
          />
          <FooterCol
            title={t.footer.company}
            links={[
              { label: t.nav.faq, href: "/#faq" },
              { label: t.nav.contact, href: "/#contact" },
              {
                label: t.nav.login,
                href: "https://app.geteasystatement.com/login",
                external: true,
              },
            ]}
          />
          <FooterCol
            title={t.footer.legal || "Legal"}
            links={[
              { label: "Privacy Policy", href: "/privacy-policy" },
              { label: "Terms & Conditions", href: "/terms-and-conditions" },
              { label: "Refund & Cancellation Policy", href: "/refund-policy" },
              { label: "Contact Us", href: "/#contact" },
            ]}
          />
        </div>

        <div className="mt-14 pt-8 border-t border-stone-800 text-sm text-stone-400 flex flex-col sm:flex-row gap-3 sm:justify-between">
          <p>{t.footer.copyright}</p>
          <p className="text-stone-400">Made for Indian shop owners.</p>
        </div>
      </div>
    </footer>
  );
};

const FooterCol = ({ title, links }) => (
  <div>
    <h3 className="font-display text-stone-50 text-base mb-4">{title}</h3>
    <ul className="space-y-3">
      {links.map((l, i) => (
        <li key={i}>
          {l.href.startsWith("/") && !l.href.includes("#") && !l.external ? (
            <Link
              to={l.href}
              className="text-sm text-stone-400 hover:text-stone-50 transition"
            >
              {l.label}
            </Link>
          ) : (
            <a
              href={l.href}
              target={l.external ? "_blank" : undefined}
              rel={l.external ? "noopener noreferrer" : undefined}
              className="text-sm text-stone-400 hover:text-stone-50 transition"
            >
              {l.label}
            </a>
          )}
        </li>
      ))}
    </ul>
  </div>
);
